export const hubspotFormSubmission = (
  portalId: string,
  formId: string,
  fields: {
    name: string
    value: string
  }[],
  legalConsentOptions: any,
  onSuccess: (message: string) => void,
  onError: (message: string) => void
) => {
  fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      submittedAt: Date.now(),
      fields,
      legalConsentOptions
    })
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.inlineMessage) onSuccess(data.inlineMessage)
    })
    .catch(() => onError('There was an issue submitting the form, please try again.'))
}
